import { useState } from 'react';
import { useUI }         from '../../context/UIContext';
import { submitEnquiry } from '../../lib/api';
import { buildRequestMessage } from '../../lib/whatsapp';

const inp = {
  width: '100%', border: '1px solid var(--grey)', padding: '10px 12px',
  fontSize: 12, outline: 'none', boxSizing: 'border-box',
  fontFamily: 'var(--font-body)', color: 'var(--dark)',
  background: '#fff', transition: 'border-color 0.2s',
};
const lbl = {
  fontSize: 11, color: 'var(--grey-dark)', display: 'block',
  marginBottom: 6, letterSpacing: '0.05em',
};

const FIELDS = [
  { name: 'name',   label: 'Your Name *',    type: 'text',  required: true,  span: 2 },
  { name: 'phone',  label: 'Phone Number *', type: 'tel',   required: true,  span: 2 },
  { name: 'brand',  label: 'Brand',          type: 'text',  required: false, span: 1 },
  { name: 'model',  label: 'Model / Style',  type: 'text',  required: false, span: 1 },
  { name: 'colour', label: 'Colour',         type: 'text',  required: false, span: 1 },
  { name: 'budget', label: 'Budget',         type: 'text',  required: false, span: 1 },
];

export default function EnquiryModal() {
  const { enquiryOpen, closeEnquiry } = useUI();
  const [form, setForm]     = useState({ name: '', phone: '', brand: '', model: '', colour: '', budget: '' });
  const [status, setStatus] = useState('idle'); // idle | loading | sent | err

  const onChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.phone) return;
    setStatus('loading');

    try {
      // 1. Save to DB first
      // await submitEnquiry({
      //   ...form,
      //   type: 'request',
      //   // description maps to any extra info
      //   description: [
      //     form.colour && `Colour: ${form.colour}`,
      //     form.budget && `Budget: ${form.budget}`,
      //   ].filter(Boolean).join(' | ') || '',
      // });
      // In handleSubmit, replace the submitEnquiry call:
      await submitEnquiry({
        name: form.name,
        phone: form.phone,
        brand: form.brand,
        model: form.model,
        colour: form.colour,
        budget: form.budget,
        description: '',   // notes/extra info — blank unless you add a notes field
        type: 'request',
      });
    } catch (_) {
      // Don't block WA even if DB save fails — still send WA
    }

    // 2. Open WhatsApp
    window.open(buildRequestMessage(form), '_blank');

    setStatus('sent');
    setTimeout(() => {
      setStatus('idle');
      closeEnquiry();
      setForm({ name: '', phone: '', brand: '', model: '', colour: '', budget: '' });
    }, 1500);
  }

  if (!enquiryOpen) return null;

  return (
    <>
      <div onClick={closeEnquiry} className="animate-fade-in"
        style={{ position: 'fixed', inset: 0, background: 'rgba(26,26,26,0.65)', zIndex: 200 }} />

      <div style={{ position: 'fixed', inset: 0, zIndex: 201, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, pointerEvents: 'none' }}>
        <div className="animate-fade-in-up" style={{ background: '#fff', width: '100%', maxWidth: 480, pointerEvents: 'all', boxShadow: 'var(--shadow-xl)' }}>

          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--grey)' }}>
            <div>
              <h2 style={{ fontSize: 13, fontWeight: 600, letterSpacing: '0.08em', color: 'var(--dark)', margin: 0 }}>REQUEST A PIECE</h2>
              <p style={{ fontSize: 12, color: 'var(--grey-mid)', marginTop: 4 }}>We'll source it for you</p>
            </div>
            <button onClick={closeEnquiry} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--grey-mid)', display: 'flex', padding: 4 }}>
              <svg width={20} height={20} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} style={{ padding: '20px 22px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {FIELDS.map(({ name, label, type, required, span }) => (
                <div key={name} style={{ gridColumn: `span ${span}` }}>
                  <label style={lbl}>{label}</label>
                  <input
                    name={name}
                    type={type}
                    required={required}
                    value={form[name]}
                    onChange={onChange}
                    style={inp}
                    onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                    onBlur={e  => e.target.style.borderColor = 'var(--grey)'}
                  />
                </div>
              ))}
            </div>

            {/* Info note */}
            <p style={{ fontSize: 11, color: 'var(--grey-mid)', margin: '12px 0 0', lineHeight: 1.6 }}>
              Your request is saved to our records and sent directly via WhatsApp for fastest response.
            </p>

            {/* Submit */}
            <button
              type="submit"
              disabled={status === 'loading' || status === 'sent'}
              style={{
                width: '100%', padding: '15px 0', marginTop: 16,
                background: status === 'sent' ? 'var(--green)' : 'var(--dark)',
                color: '#fff', fontSize: 11, letterSpacing: '0.2em',
                textTransform: 'uppercase', fontWeight: 600, border: 'none',
                cursor: status !== 'idle' ? 'not-allowed' : 'pointer',
                opacity: status === 'loading' ? 0.7 : 1,
                transition: 'all 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              }}
              onMouseEnter={e => { if (status === 'idle') e.currentTarget.style.background = 'var(--gold)'; }}
              onMouseLeave={e => e.currentTarget.style.background = status === 'sent' ? 'var(--green)' : 'var(--dark)'}>
              {status === 'loading' ? 'Saving & Sending…'
                : status === 'sent' ? '✓ Sent!'
                : (
                  <>
                    <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                    Save & Send via WhatsApp
                  </>
                )
              }
            </button>
          </form>
        </div>
      </div>
    </>
  );
}